module.exports = __webpack_public_path__ + "static/media/search.743dca1d.svg";